import API from "../../../api/index";
import { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { Stack, Box, Skeleton } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import EventIcon from "@mui/icons-material/Event";
import { boxStyle } from "../../../theme";
import dayjs from "dayjs";

const DaysRemaining = () => {
  const [daysRemaining, setDaysRemaining] = useState(0);
  const [scadenza, setScadenza] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController()
    API.getLicense(controller.signal).then((response) => {
      setDaysRemaining(response.data.RemaningDays);
      setScadenza(response.data.Date);
    }).catch((err) => {
      if (err.name !== 'CanceledError') {
        setDaysRemaining(0);
        setScadenza(dayjs().format("YYYY-MM-DD"));
      }
    }).finally(() => setLoading(false));
    return () => controller.abort()
  }, []);

  const iconColor = daysRemaining <= 14 ? "#931a1d" : daysRemaining <= 60 ? "orange" : "#78d168";

  return (
    <Box sx={{ ...boxStyle, display: "flex", flexDirection: "column" }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
        <Typography sx={{ fontSize: 13, fontWeight: 500, color: "#888" }}>
          License Expiry
        </Typography>
        <Box
          sx={{
            width: 36, height: 36, borderRadius: "10px",
            backgroundColor: "rgba(255, 255, 255, 0.06)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <EventIcon sx={{ fontSize: 18, color: "#888" }} />
        </Box>
      </Stack>

      {loading ? (
        <Stack spacing={1}>
          <Skeleton variant="rounded" width="80%" height={20} sx={{ bgcolor: "rgba(255,255,255,0.08)" }} />
          <Skeleton variant="rounded" width="65%" height={20} sx={{ bgcolor: "rgba(255,255,255,0.08)" }} />
        </Stack>
      ) : (
        <Stack spacing={1}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <VerifiedIcon sx={{ fontSize: 16, color: iconColor }} />
            <Typography sx={{ fontSize: 14 }}>Expires: {scadenza}</Typography>
          </Stack>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <VerifiedIcon sx={{ fontSize: 16, color: iconColor }} />
            <Typography sx={{ fontSize: 14 }}>
              Days left:{" "}
              <span style={{ color: iconColor, fontWeight: 600 }}>{daysRemaining}</span>
            </Typography>
          </Stack>
        </Stack>
      )}

      <Typography sx={{ fontSize: 12, color: "#555", marginTop: "auto", paddingTop: 1 }}>
        Nearest license expiration date
      </Typography>
    </Box>
  );
};

export default DaysRemaining;
